import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div className="social_icons">
        <a href="https://www.linkedin.com/in/haihd/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
        <a href="https://github.com/haihd" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="mailto:dustin.dev@hotmail.com" rel="noreferrer"><EmailIcon/></a>
      </div>
    </footer>
  );
}

export default Footer;